module.exports = __webpack_public_path__ + "media/bifold-vertical.f874cb75.mp4";